import { ChartCanvas } from "@/components/analytics/ChartCanvas";
import { useCaTrendChartConfig } from "../hooks/useCaTrendChartConfig";

interface CaTrendPoint {
  bucket: string;
  gross: number;
  gain: number;
}

export function CaTrendSection({ trend }: { trend: CaTrendPoint[] }) {
  const chartConfig = useCaTrendChartConfig(trend);

  return (
    <div className="mb-6 rounded-lg border border-border bg-card p-4">
      <p className="mb-0.5 text-[11.5px] font-semibold text-body">Évolution du CA et du gain</p>
      <p className="mb-3 text-[10.5px] text-muted-foreground">
        Granularité adaptée à la période sélectionnée (jour, semaine ou mois).
      </p>
      {trend.length === 0 ? (
        <p className="py-12 text-center text-[11.5px] text-muted-foreground">
          Aucune donnée sur cette période.
        </p>
      ) : (
        <ChartCanvas label="Évolution du CA et du gain" config={chartConfig} />
      )}
    </div>
  );
}
